
import platform from "platform";
// import {uuid} from "@/helpers";

import { LogValue } from '@/types/LogValue'
import { Commit } from 'vuex';


export default {
    namespaced: true,
    state: {
        LogValue: <LogValue>{
            access: "web",
            appversion: process.env.VUE_APP_AppVersion,
            os: `${platform.os?.family} ${platform.os?.version}`, //"android 10"
            device: 'platform.os.family', // "andorid/ios/windows/macos"
            deviceid: (localStorage.getItem('DeviceID')) ? localStorage.getItem('DeviceID') : undefined,
            lang:'th',
           
        }

    },
    getters: {
        // [types.MUTATION]: state => state.value,
        // eslint-disable-next-line
        getLogValue: (state:any):string => state.LogValue,
    },
    mutations: {
        // [types.MUTATION](state, value) {
        //     state.value = value;
        // },
        // eslint-disable-next-line
        SetDeviceID(state:any, payload:string) :void{
            state.LogValue.deviceid = payload;
        },

    },
    actions: {
        SetDeviceID({ commit }: { commit: Commit }, payload: string) : void{
            commit('SetDeviceID', payload)
        },
    },
    
}